import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../../../../components/Button';
import { Section } from '../../../../components/Section';
import { Text } from '../../../../components/Text';
import { Spacing } from '../../../../theme/Spacing';
import { SettingsEmailChangeNewEmailModal } from './SettingsEmailChangeNewEmailModal';
import { SettingsEmailChangePassword } from './SettingsEmailChangePassword';
import { SettingsEmailChangeVerificationModal } from './SettingsEmailChangeVerificationModal';

const StyledButton = styled(Button)`
  height: 2.3rem;
  margin-top: ${Spacing.s};
  width: fit-content;

  &:hover {
    background-color: ${({ theme }) => theme.mainHover};
  }
`;

export const SettingsEmailChange: React.FC = () => {
  const [newEmailPasswordModalVisible, setNewEmailPasswordModalVisible] =
    useState(false);
  const [newEmailModalVisible, setNewEmailModalVisible] = useState(false);
  const [emailVerificationModalVisible, setEmailVerificationModalVisible] =
    useState(false);
  const [newEmail, setNewEmail] = useState('');

  const { t } = useTranslation();

  const onNewEmailPasswordSuccess = () => {
    setNewEmailPasswordModalVisible(false);
    setNewEmailModalVisible(true);
  };

  const onNewEmailSuccess = (email: string) => {
    setNewEmail(email);
    setNewEmailModalVisible(false);
    setEmailVerificationModalVisible(true);
  };

  return (
    <Section title={t('settings.general.changeEmail.title')}>
      <Text color="fgSecondary">
        {t('settings.general.changeEmail.description')}
      </Text>

      <StyledButton
        onClick={() => setNewEmailPasswordModalVisible(true)}
        width="12rem"
      >
        {t('settings.general.changeEmail.start.button')}
      </StyledButton>

      <SettingsEmailChangePassword
        open={newEmailPasswordModalVisible}
        onClose={() => setNewEmailPasswordModalVisible(false)}
        onSuccess={onNewEmailPasswordSuccess}
      />

      <SettingsEmailChangeNewEmailModal
        open={newEmailModalVisible}
        onClose={() => setNewEmailModalVisible(false)}
        onSuccess={onNewEmailSuccess}
      />

      <SettingsEmailChangeVerificationModal
        open={emailVerificationModalVisible}
        onClose={() => setEmailVerificationModalVisible(false)}
        newEmail={newEmail}
      />
    </Section>
  );
};
